import RichText from "@/components/RichText";

const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { label: "Premier critère", value_a: "—", value_b: "—" } },
  { id: "fallback-2", props: { label: "Deuxième critère", value_a: "—", value_b: "—" } },
];

const DEFAULTS = {
  eyebrow: "", heading: "Comparatif", subheading: "",
  column_a_label: "Formule essentielle", column_b_label: "Formule complète", anchor_id: "",
};

export default function ComparisonTableSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const rows = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false && b.props?.label);
  if (!rows.length) return null;

  return (
    <section id={t.anchor_id || undefined} className="max-w-[900px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <div className="text-center">
        {t.eyebrow && (
          <RichText as="p" className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-3" html={t.eyebrow} />
        )}
        <RichText
          as="h2"
          className="font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] text-ink"
          html={t.heading}
        />
        {t.subheading && <RichText as="p" preserveParagraphs className="text-[16px] text-graphite mt-4" html={t.subheading} />}
      </div>

      {/* Le tableau défile seul en petite largeur : trois colonnes de texte
          ne tiennent pas sur un téléphone, et la page ne doit jamais défiler
          horizontalement dans son ensemble. */}
      <div className="mt-8 overflow-x-auto border-control border-stone rounded-xl bg-white">
        <table className="w-full min-w-[520px] border-collapse text-left">
          <thead>
            <tr className="border-b border-stone">
              <th className="px-5 py-3 text-[12px] font-semibold uppercase tracking-wide text-ash" />
              <th className="px-5 py-3 text-[13px] font-semibold text-ink">{t.column_a_label}</th>
              <th className="px-5 py-3 text-[13px] font-semibold text-ink">{t.column_b_label}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((block) => (
              <tr key={block.id} data-block-key={block.id} className="border-b border-stone last:border-b-0">
                <th scope="row" className="px-5 py-3 text-[14px] font-medium text-graphite">{block.props.label}</th>
                <td className="px-5 py-3 text-[14px] text-ink">{block.props.value_a}</td>
                <td className="px-5 py-3 text-[14px] text-ink">{block.props.value_b}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
